export  class Color {
    static BG_LIGHT = '#e2423a';
    static BG_DARK = '#a5302a';
}
